import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const LEGALSFOOTERBLOCK_LEGACY_FIELD_ORDER = [
  "display_powered_by_dood",
  { type: 'groupedFields', handle: 'colors', fields: ["backgroundColor","borderColor","logoColor"] }
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  legalsFooterBlockDescriptor: _generatedLegalsFooterBlockDescriptor,
  legalsFooterBlockBlocDefinition,
  legalsFooterBlockDashboardLayout,
  legalsFooterBlockConfig,
  legalsFooterBlockResolveConfig,
  legalsFooterBlockProperties,
} = doodBlockConfig(
  {
    name: "Legals footer",
    componentType: 'LegalsFooterBlockComponent',
    category: 'footer',
    description: "Legals footer.",
    keywords: [],
    allowedIn: [
      { bloc: '*', slot: 'footer' },
    ],

    sharedFields: {},
    slots: [
      {
        key: 'extras',
        name: 'pages.blocks.legals-footer.extras.label',
        accept: 'explicitOnly',
        allowedTypes: ["ContainerBlock", "BigFooterBodySocialNetworksBlock"],
        slotItemFormat: 'ids',
      },
      {
        key: 'links',
        name: 'pages.blocks.legals-footer.links.label',
        accept: 'explicitOnly',
        allowedTypes: ["LegalsFooterLinkItemBlock", "CookieConsentLinkItemBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    display_powered_by_dood: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.legals-footer.display-powered-by-dood.label",
      }
    }),
    colors: {
      backgroundColor: propertyValue({
        type: 'color',
        value: { type: 'palette', value: 'neutral-800' },
        options: {
          label: "pages.blocks.legals-footer.background-color.label",
        }
      }),
      borderColor: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          label: "pages.blocks.legals-footer.border-color.label",
        }
      }),
      logoColor: propertyValue({
        type: 'select',
        value: "light",
        options: {
          label: "pages.blocks.legals-footer.logo-color.label",
          help: "pages.blocks.legals-footer.logo-color.help",
          choices: [
            {
              value: "light",
              label: "pages.blocks.legals-footer.logo-color.options.light",
            },
            {
              value: "dark",
              label: "pages.blocks.legals-footer.logo-color.options.dark",
            }
          ]
        }
      })
    }
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.legals-footer.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.legals-footer.fieldset.appearance.label",
            fields: ["colors.backgroundColor", "colors.borderColor"],
          },
          {
            legend: "pages.blocks.legals-footer.fieldset.extras.label",
            fields: ["extras"],
          },
          {
            legend: "pages.blocks.legals-footer.fieldset.links.label",
            fields: ["links"],
          },
          {
            legend: "pages.blocks.legals-footer.fieldset.dood-logo.label",
            fields: [
              "display_powered_by_dood",
              {
                prop: "colors.logoColor",
                visibleWhen: { display_powered_by_dood: true },
              },
            ],
          },
        ],
      },
    ],
  })
);

export function legalsFooterBlockDescriptor(): IBlockDescriptor;
export function legalsFooterBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function legalsFooterBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedLegalsFooterBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedLegalsFooterBlockDescriptor, legalsFooterBlockProperties, fieldOrder);
}

export {
  legalsFooterBlockBlocDefinition,
  legalsFooterBlockDashboardLayout,
  legalsFooterBlockProperties,
  legalsFooterBlockConfig,
  legalsFooterBlockResolveConfig,
};

export type LegalsFooterBlockConfig = typeof legalsFooterBlockConfig;
